import React from 'react';
import PropTypes from 'prop-types';
import Interweave from 'interweave';
import ImageHero from './imageHero';
import * as StyledApartmentDetails from './apartmentDetails.styles';
import {
	Container,
	Columns, Column,
	H1, H2
} from '../base';
import withNewestApartments from '../../hoc/withNewestApartments';
import ApartmentShowcase from '../apartmentShowcase';
import ApplicationButton from './applicationButton';
import { ReactComponent as IconFm2 } from '../../figures/fm2.svg';
import { ReactComponent as IconSofa } from '../../figures/sofa.svg';
import { ReactComponent as IconToilet } from '../../figures/toilet.svg';
import { ReactComponent as IconBed } from '../../figures/bed.svg';
import { ReactComponent as IconDoor } from '../../figures/door.svg';
import useGet from '../../hooks/useGet';
import { formatCurrency } from '../../helpers/formatting/formatting';

const ApartmentDetails = ({
	apartment,
	page
}) => {
	const {
		Id,
		Address,
		Description,
		Zip,
		Rent,
		SquareMeters,
		Rooms,
		BathRooms,
		BedRooms,
		Garage,
		Images
	} = apartment
	const { response, loading, error } = useGet(`/api/apartments/related/${Id}`);
	const NewestApartments = withNewestApartments(ApartmentShowcase);

	return (
		<>
			<StyledApartmentDetails.Wrapper>
				<ImageHero images={Images} />
				<Container>
					<Columns>
						<Column tablet={6 / 12} desktopLarge={7 / 12}>
							<StyledApartmentDetails.Content>
								<StyledApartmentDetails.TitleRow>
									<StyledApartmentDetails.TitleStreetWrapper>
										<H1>{Address}</H1>
										<div>{Zip}</div>
									</StyledApartmentDetails.TitleStreetWrapper>
									<StyledApartmentDetails.PriceWrapper>
										<StyledApartmentDetails.Price>
											{formatCurrency(Rent)}
										</StyledApartmentDetails.Price>
										<span>/</span>
										<StyledApartmentDetails.PricePr>mán</StyledApartmentDetails.PricePr>
									</StyledApartmentDetails.PriceWrapper>
								</StyledApartmentDetails.TitleRow>
								<StyledApartmentDetails.MainText>
									<Interweave content={Description} />
								</StyledApartmentDetails.MainText>
							</StyledApartmentDetails.Content>
						</Column>
						<Column tablet={1 / 12} />
						<Column tablet={5 / 12} desktopLarge={4 / 12}>
							<StyledApartmentDetails.InfoBox>
								<H2 marginBottom>Upplýsingar</H2>
								<StyledApartmentDetails.InfoBoxLine>
									<IconFm2 />
									<div>{`${SquareMeters} fm`}</div>
								</StyledApartmentDetails.InfoBoxLine>
								<StyledApartmentDetails.InfoBoxLine>
									<IconSofa />
									<div>{`${Rooms} herbergi`}</div>
								</StyledApartmentDetails.InfoBoxLine>
								<StyledApartmentDetails.InfoBoxLine>
									<IconToilet />
									<div>{`${BathRooms} baðherbergi`}</div>
								</StyledApartmentDetails.InfoBoxLine>
								<StyledApartmentDetails.InfoBoxLine>
									<IconBed />
									<div>{`${BedRooms} svefnherbergi`}</div>
								</StyledApartmentDetails.InfoBoxLine>
								<StyledApartmentDetails.InfoBoxLine>
									<IconDoor />
									<div>{`Bílskur: ${Garage}`}</div>
								</StyledApartmentDetails.InfoBoxLine>
								{
									!page.Values.HideApplicationLink && (
										<ApplicationButton
											id={Id}
											hidden={page.Values.HideApplicationButton} />
									)
								}
							</StyledApartmentDetails.InfoBox>
						</Column>
					</Columns>
					<NewestApartments
						title="Fleiri íbúðir"
						maxApts={3}
						useAnimation={false}
						loading={loading}
						error={error}
						apartments={response !== null ? [response.data[0], response.data[1], response.data[2]] : null} />
				</Container>
			</StyledApartmentDetails.Wrapper>
		</>
	);
};

ApartmentDetails.propTypes = {
	apartment: PropTypes.object.isRequired,
	page: PropTypes.object.isRequired
};

ApartmentDetails.defaultProps = {
};

export default ApartmentDetails;
